
//login/ Sign up  linkCreateAccount
document.addEventListener("DOMContentLoaded", function () {
  var reCreate = document.getElementById("linkForgotPassword");
  var haveAcc = document.getElementById("linkLogin");
  var resetPass = document.getElementById("linkRestPassword");
  var formLogin = document.getElementById("Login");
  var formForgotPass = document.getElementById("ForgotPassword");
  var formResetPass = document.getElementById("ResetPassword");

  haveAcc && haveAcc.addEventListener("click", function (e) {
    e.preventDefault();

    show(formLogin);
    hide(formForgotPass);
  });

  reCreate && reCreate.addEventListener("click", function (e) {
    e.preventDefault();

    hide(formLogin);
    show(formForgotPass);
  });

  resetPass && resetPass.addEventListener("click", function (e) {
    e.preventDefault();

    hide(formForgotPass);
    show(formResetPass);
  });

});


function hide(elem) {
  elem.classList.add("form--hidden");
  elem.classList.remove("form--unhidden");
}

function show(elem) {
  elem.classList.add("form--unhidden");
  elem.classList.remove("form--hidden");
}

// menu collapse

document.addEventListener("DOMContentLoaded", function () {
  var menuBtn = document.querySelector(".js-menuToggle");
  menuBtn.addEventListener("click", () => {
    console.log("clicked");
    const manuPanel = document.querySelector(".menu_panel");
    manuPanel.classList.toggle("open");
    if (!manuPanel.classList.contains('open')){
      const submenu = document.querySelectorAll('.main_item__submenu');
      const submenuItem = document.querySelectorAll('.js-mainmenu');
      submenu && submenu.forEach(item => item.style.display = 'none');
      submenuItem && submenuItem.forEach(item => item.classList.remove('active-menu'));
    }
  })
});

const manuItemSelector = document.querySelectorAll('.menu_items img');
if (manuItemSelector && manuItemSelector.length) {
  manuItemSelector.forEach(function(item){
    item.addEventListener('click', function(){
      document.querySelector(".js-menuToggle").click();
    });
  });
}


// tabs

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}
// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();


// video 

const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
  if (video.paused || video.ended) {
    video.play();
  } else {
    video.pause();
  }
}

if (circlePlayButton && video) {
  circlePlayButton.addEventListener("click", togglePlay);
  video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
  });
  video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
  });
}



// notification hide & show






// swiper
// var swiper = new Swiper('.swiper-container', {
//   pagination: '.swiper-pagination',
//   slidesPerView: 3,
//   paginationClickable: true,
//   spaceBetween: 30,
//   freeMode: true,
//   autoplay: {
//     delay: 5000,
//   },
// });

// slider

//DOM Elements begin with $
const $slides = document.querySelectorAll('.slide');
const SLIDER_INTERVAL = 4000;

const init = () => {
  const $sliderBtns = document.querySelectorAll('.slider__btn');
  $sliderBtns.forEach(btn => btn.addEventListener('click', sliderBtnHandler));

  generateDots();

  //slider auto-play
  //setInterval(nextSlide, SLIDER_INTERVAL);
};

const sliderBtnHandler = ({ target }) => {
  const action = target.dataset.action;

  if (action === "next") {
    nextSlide();
  } else if (action === "prev") {
    prevSlide();
  }
};

const generateDots = () => {
  const $dotsWrap = document.querySelector('.slider__dots');

  $slides.forEach((slide, i) => {
    const $dot = document.createElement('div');
    $dot.classList.add('dot');
    $dot.dataset.id = slide.dataset.id;
    $dot.addEventListener('click', dotClickHandler);

    $dotsWrap.appendChild($dot);
    i === 0 && $dot.classList.add('dot-active');
  });
};

const dotClickHandler = ({ target }) => {
  const id = target.dataset.id;
  const $dots = document.querySelectorAll('.dot');

  $slides.forEach((slide, i) => {
    //Switch slides
    if (id !== slide.dataset.id) {
      slide.classList.remove('slide-active');
    } else {
      slide.classList.add('slide-active');
    }

    //Switch dots
    if (id !== $dots[i].dataset.id) {
      $dots[i].classList.remove('dot-active');
    } else {
      $dots[i].classList.add('dot-active');
    }

  });
};

const nextSlide = () => {
  const $currentSlide = document.querySelector('.slide-active');
  let nextIndex = parseInt($currentSlide.dataset.id);
  if (nextIndex >= $slides.length) {
    nextIndex = 0; //return to 0 when pressed on next of the last slide
  }
  const $nextSlide = $slides[nextIndex];
  $currentSlide.classList.remove('slide-active');
  $nextSlide.classList.add('slide-active');

  setActiveDot(nextIndex);
};

const prevSlide = () => {
  const $currentSlide = document.querySelector('.slide-active');
  let prevIndex = parseInt($currentSlide.dataset.id) - 1;

  if (prevIndex < 1) {
    prevIndex = $slides.length - 1;
  } else {
    //because I start with 1, and the highest val will be 4 (index of 4 is the last element so nothing is gonna change), so we have to decrease it once more
    prevIndex--;
  }

  const $prevSlide = $slides[prevIndex];
  $currentSlide.classList.remove('slide-active');
  $prevSlide.classList.add('slide-active');

  setActiveDot(prevIndex);
};

const setActiveDot = index => {
  const $nextDot = document.querySelectorAll('.dot')[index];
  const $currDot = document.querySelector('.dot-active');
  $currDot.classList.remove('dot-active');
  $nextDot.classList.add('dot-active');
};

init();